module.exports = __webpack_public_path__ + "static/10-90e39772d6859a01a47af1bf768ac0b9.jpg";